import styled from 'styled-components';
import { Field } from 'formik';

export const FormContainer = styled.div`
  width: 300px;
  padding: 10px;
  background: var(--white-color);
  border-radius: 20px;
  @media screen and (min-width: 768px) {
    width: 533px;
  }
`;
export const FormTitle = styled.div`
  padding-top: 20px;

  font-size: 26px;
  font-weight: 500;
  text-align: center;
`;

export const Input = styled(Field)`
  margin-left: 20px;
  width: 243px;
  height: 30px;
  outline: none;
  border: none;
  ::placeholder {
    font-size: 18px;
  }
  @media screen and (min-width: 768px) {
    width: 373px;
  }
`;

export const Error = styled.p`
  position: absolute;
  font-size: 12px;
  color: red;
  top: -24px;
`;

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  border: var(--white-color);
  border-bottom: 1px solid #e0e0e0;
  margin-top: 40px;

  &:hover {
    border-bottom: 1px solid #1a8f75;
  }
`;

export const Textarea = styled.textarea`
  margin-top: 40px;
  padding: 10px;

  width: 280px;
  height: 80px;

  border: none;
  outline: 1px solid #e0e0e0;

  resize: none;

  @media screen and (min-width: 768px) {
    width: 480px;
  }
`;

export const Btn = styled.button`
  width: 280px;
  height: 50px;
  margin-top: 40px;
  margin-bottom: 40px;
  background-color: var(--light-green-color);
  border-radius: 20px;

  @media screen and (min-width: 768px) {
    width: 300px;
  }

  &:disabled {
    background-color: #1a8f75;
  }

  &:hover,
  &:focus {
    background-color: #1a8f75;
  }
`;

export const BtnTitle = styled.span`
  color: var(--white-color);
`;
